import { Box, useTheme } from "@mui/material";

interface ArticlesSectionWrapperProps {
    children: JSX.Element;
}

export const ArticlesSectionWrapper = (props: ArticlesSectionWrapperProps) => {
    const theme = useTheme();
    const { children } = props;

    return (
        <Box
            sx={{
                padding: theme.spacing(2, 0),
                width: "100%",

                "& .MuiGrid-root": {
                    width: "unset",
                },
            }}
        >
            {children}
        </Box>
    );
};
